import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { database } from "../../database/firebase";

const useMembers = (roomId) => {
  const [membersData, setMembersData] = useState([]);

  useEffect(() => {
    const getMembersData = async () => {
      try {
        await onSnapshot(
          query(
            collection(database, "userRooms", roomId, "members"),
            orderBy("timestamp", "asc")
          ),
          (snapshot) => {
            setMembersData(
              snapshot.docs.map((doc) => ({
                data: doc.data(),
                id: doc.id,
              }))
            );
          }
        );
      } catch (error) {
        alert(error.message);
      }
    };

    getMembersData();
  }, [roomId]);

  return [membersData];
};

export default useMembers;
